import { Translate } from '@dreryk/react-common';
import { appendTestableElementAttributes } from '@dreryk/react-components';

import { formsTemplatesTranslationKeys } from '../translations';

import { StyledFormsTemplateReadOnlyNoInformation } from './FormsTemplateReadOnlyNoInformation.styled';

export const FormsTemplateReadOnlyNoInformation = (): JSX.Element => {
   return (
      <StyledFormsTemplateReadOnlyNoInformation {...appendTestableElementAttributes('noInformation')}>
         <Translate>{formsTemplatesTranslationKeys.noInformation}</Translate>
      </StyledFormsTemplateReadOnlyNoInformation>
   );
};
